import { render, staticRenderFns } from "./UnsupportedBrowserNotification.vue?vue&type=template&id=5572e05e"
import script from "./UnsupportedBrowserNotification.vue?vue&type=script&lang=js"
export * from "./UnsupportedBrowserNotification.vue?vue&type=script&lang=js"
import style0 from "./UnsupportedBrowserNotification.vue?vue&type=style&index=0&id=5572e05e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports